(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-footer"]) return;
  try {
    
  var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  document.addEventListener('DOMContentLoaded', () => {
    const popup = document.getElementById('newsletter-popup')
    const closePopup = document.getElementById('close-newsletter-popup')
    const urlParams = new URL(window.location.href).searchParams;
    const customerPosted = urlParams.get('customer_posted');
    let popupDismissed = getCookie("prevent_popup");
    const popupDelay = popup.dataset.delay * 1000;
    if ( !popupDismissed && !customerPosted) {
      const openPopupTimeout = setTimeout(function openPopup(){
        popup.showModal();
        popup.style.display = "flex"
        setCookie("prevent_popup", true, 365);
      }, popupDelay);
    }
    closePopup.addEventListener('click', () => {
      popup.close();
      popup.style.display = "none"
    })
  })


  } catch(e) { console.error(e); }
})();
})();
